const getters = {
  token: state => state.user.token,
  chatToken: state => state.user.chatToken
}

export default getters
